import PropTypes from "prop-types";
import React from "react";
import { getStatus } from "redux-store/device-statuses/selectors";
import { getPoint, hasPoint } from "redux-store/devices/selectors";
import { GoogleMap } from "ui/map/google-map.js";
import { MapboxMap } from "ui/map/mapbox-map.js";

class DevicesMap extends React.PureComponent {
  static get propTypes() {
    return {
      devices: PropTypes.array.isRequired,
      deviceStatuses: PropTypes.object.isRequired,
      deviceStatusOnline: PropTypes.bool,
      featureFlags: PropTypes.object,
    };
  }

  _isMapboxEnabled() {
    if (!this.props.featureFlags) {
      return false;
    }
    return this.props.featureFlags["is-cortex-mapbox-widget-enabled"] || false;
  }

  _getMarkers() {
    const { devices, deviceStatuses } = this.props;
    return devices
      .filter((device) => hasPoint(device))
      .map((device) => {
        const { id } = device;
        const coords = getPoint(device);
        const status = deviceStatuses[id] || {};
        const deviceStatus = getStatus(status);

        return {
          device: { ...device },
          coords,
          deviceStatus,
          showInfoWindow: true,
        };
      });
  }

  render() {
    const { deviceStatuses, deviceStatusOnline, ...rest } = this.props;
    const markers = this._getMarkers();

    const mapProps = {
      ...rest,
      markers,
      deviceStatuses,
      deviceStatusOnline,
    };

    return this._isMapboxEnabled() ? (
      <MapboxMap {...mapProps} />
    ) : (
      <GoogleMap {...mapProps} />
    );
  }
}

export { DevicesMap };
